"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCardMastercard = function CreditCardMastercard(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 32 7.075"
  }), react_1.default.createElement("g", {
    transform: "translate(-1297 -275.633)"
  }, react_1.default.createElement("g", {
    transform: "translate(1297 275.633)"
  }, react_1.default.createElement("path", {
    fill: "#016fd0",
    fillRule: "evenodd",
    d: "M164.212,12.362,162.1,7.633h-2.7v6.8l-3.049-6.8h-2.305L151,14.708h1.837l.625-1.6h3.479l.664,1.6h3.519V9.43l2.305,5.277h1.6l2.345-5.16v5.16h1.72V7.633h-2.775l-2.111,4.729Zm-8.991-.781h-1.055l1.055-2.463V9.2l1.056,2.385Z",
    transform: "translate(-151 -7.633)"
  }), react_1.default.createElement("path", {
    fill: "#016fd0",
    d: "M175.156,11.048l1.251-1.329,1.824-2.072h-2.175L174.1,9.8l-1.955-2.151h-6.84v7h6.645l2.071-2.307,2.033,2.345h2.175l-1.824-2.149ZM171.014,13.2h-3.948V11.791H170.9V10.462h-3.831V9.172h3.948l1.955,1.876Z",
    transform: "translate(-146.231 -7.628)"
  }))));
};

CreditCardMastercard.displayName = 'CreditCardMastercard';
exports.default = CreditCardMastercard;